import React, { Fragment } from 'react';
import Upload from './Upload';
import Requirements from './Requirements';
import proofofwork from '../../images/proofofwork.jpg';

const good = ['Passport', 'Residency card', 'Birth certificate', 'Citizenship card', 'Work permit'];
const bad = ['Cannot be expired', 'Resume is not a valid document', 'Health card'];
const description = 'We need proof that you are legally able to work in Canada.';

const DriversLicense = props => (
  <Fragment>
    <h2 className="upload-header">Proof of Work Eligibility</h2>

    {props.employmentEligibilityImage ? null : (
      <Requirements good={good} bad={bad} description={description}>
        <div className="license-container">
          <img
            className="license"
            src={proofofwork}
            alt="Driver's License"
          />
        </div>
      </Requirements>
    )}

    <Upload {...props} />
  </Fragment>
);

export default DriversLicense;



// WEBPACK FOOTER //
// ./src/components/MissingDocs/Eligibility.js